import { CalendarDate } from "@internationalized/date";

export const legalTimeZone = "Europe/Berlin";

export const dateIsAfter = (date: CalendarDate, thresholdDate: CalendarDate): boolean => {
  return date.compare(thresholdDate) > 0;
};
